import { Component, OnInit } from '@angular/core';
import { RootLayout } from '../../@hornbillfx/layouts';
import { SidebarMenu } from '../../../assets/objects/sidebar-menu';
import { AuthService } from './admin-services/auth.service';
import { Router } from '@angular/router';
import { pagesToggleService } from '../../@hornbillfx/services/toggler.service';
import * as $ from 'jquery';
import { UserService } from '../../services/user.service';
import { NotificationService } from './service/notification.service';
import { EncriptDecriptService } from '../../services/encriptdecript';
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent extends RootLayout implements OnInit {

  public menuLinks = SidebarMenu;
  public userDetail: any;
  Admin: any;
  fullName: string;
  roleName: any;
  public userObject:any;
  constructor(public toggler: pagesToggleService,
    public router: Router, private userService:UserService,
    private encriptDecript:EncriptDecriptService,
    private authService: AuthService,private notificationService:NotificationService) {
    super(toggler, router);
    this.userObject = this.encriptDecript.getLocalStorage('userObject');
    this.userDetail = JSON.parse(this.userObject);
    this.Admin=this.userDetail.isAdmin;
  }
  
  ngOnInit() {
    this.getPermittedMenuLinks();
    this.changeLayout('menu-pin');
    this.changeLayout('menu-behind');
    // Will sidebar close on screens below 1024
    this.autoHideMenuPin();
    if(this.Admin!=true){
      this.roleName = this.userDetail.roles[0]?this.userDetail.roles[0].name:'';
    }

    // $(document).ready(function(){
    //   $( '.page-sidebar .sidebar-menu .menu-items > li' ).has('a.active').addClass( 'menu-li-active' );
    // });
  }

  private getPermittedMenuLinks() {
    this.fullName = this.userDetail.firstName;
    permitedMenuLinks = [];
    SidebarMenu.forEach((ele => {
      if (this.authService.authComponent(ele.routerLink)) {
        permitedMenuLinks.push(ele);
      }
    }));
    if (!this.userDetail.isAdmin) {
      permitedMenuLinks.splice(0, 0, SidebarMenu[0]); // pushing dashboard as it  default for all admins.
    }
    return this.menuLinks = permitedMenuLinks;
  }


  logout() {
        const userId=  this.userDetail.userId;
        var logo = localStorage.getItem('logo');
        this.userService.logOut(userId).subscribe(response=>{
          this.router.navigate(['/login/',logo]);
          localStorage.clear();
          sessionStorage.clear();
    },(error)=>{
    })
  }
}


export let permitedMenuLinks = [];



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/admin.component.ts